module.exports = __webpack_public_path__ + "img/69.ee70a4d8.jpg";